import { Injectable } from '@angular/core';

import { NotificationSourceEnum } from '../../shared/enums/notification-source.enum';

@Injectable({
    providedIn: 'root'
})
export class NotificationsRedirectService {

    constructor() { }

    public getNotificationAutoRedirectPath(source: NotificationSourceEnum, id: string): string | null {
        switch (source) {
            case NotificationSourceEnum.AssignmentTransferred:
            case NotificationSourceEnum.OpenAssignmentNotTookOver:
                return `/assignments/${id}`;
            case NotificationSourceEnum.NewNewsAvailable:
                return `/news/${id}`;
            case NotificationSourceEnum.NewDocumentAvailable:
                return `/know-how?documentId=${id}`;
            case NotificationSourceEnum.NewPlanningAvailable:
                return `/assignments/schedules/${id}`;
            case NotificationSourceEnum.NewOpenAssignmentsAvailable:
                return `/assignments/open`;
            case NotificationSourceEnum.AssignmentTakenOver:
            case NotificationSourceEnum.Example:
                return null;
            case NotificationSourceEnum.None:
            default:
                return '/home';
        }
    }

    public getNotificationManuarlActionUrl(source: NotificationSourceEnum): string | null {
        switch (source) {
            case NotificationSourceEnum.AssignmentTakenOver:
                return '/assignments/my';
            case NotificationSourceEnum.AssignmentTransferred:
            case NotificationSourceEnum.OpenAssignmentNotTookOver:
            case NotificationSourceEnum.NewNewsAvailable:
            case NotificationSourceEnum.NewDocumentAvailable:
            case NotificationSourceEnum.NewPlanningAvailable:
            case NotificationSourceEnum.NewOpenAssignmentsAvailable:
            case NotificationSourceEnum.AssignmentTakenOver:
            case NotificationSourceEnum.None:
            case NotificationSourceEnum.Example:
            default:
                return null;
        }
    }

    public getNotificationManuarlActionName(source: NotificationSourceEnum): string | null {
        switch (source) {
            case NotificationSourceEnum.AssignmentTakenOver:
                return 'Zu meinen Einsätzen';
            case NotificationSourceEnum.AssignmentTransferred:
            case NotificationSourceEnum.OpenAssignmentNotTookOver:
            case NotificationSourceEnum.NewNewsAvailable:
            case NotificationSourceEnum.NewDocumentAvailable:
            case NotificationSourceEnum.NewPlanningAvailable:
            case NotificationSourceEnum.NewOpenAssignmentsAvailable:
            case NotificationSourceEnum.AssignmentTakenOver:
            case NotificationSourceEnum.None:
            case NotificationSourceEnum.Example:
                return null;
        }
    }
}
